// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.85.0',
  revision: 'c4d33dc6b',
  branch: 'master',
  date: 'Thu, 26 Feb 2026 11:49:28 GMT'
};